import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DOW_DEMO_DNA1_2 = {
  title: `She begins her day by checking the \nhealth of data applications and data \npipelines using the<span style="color: #BEE3FF;"> Pipeline Monitoring function</span>.`,
  subtitle: "Data Operations Workbench demo",
  label: [
    { iconPath: "start.png", text: "Monitoring" },
    { iconPath: "start.png", text: "Pipeline Monitoring" },
  ],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(107),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(105),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA1/DNA1_DOW_DEMO_02_Board.png",
          imageStyle: {
            position: "absolute",
            right: "132px",
            bottom: "232.38px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_02_PopUp.png",
          imageStyle: { position: "absolute", right: "265px", bottom: "498px" },
        },
      ]}
      pageNumber={106}
    />
  ),
};
